import React from "react";
import classNames from "classnames";
import { useTranslate } from "../../translate";
import { trackOutboundClick } from "../shared/AnalyticsTracker";

function AtlasCardFooter(props) {
    const { className, phone, website, coords } = props;
    const translate = useTranslate();
    return (
        <ul className={classNames("trpr-atlas-card__footer", className)}>
            {phone && (
                <li>
                    <a onClick={() => trackOutboundClick("tripper.app", website)} href={`tel:${phone}`}>
                        <span>{phone}</span>
                    </a>
                </li>
            )}
            {website && (
                <li>
                    <a
                        onClick={() => trackOutboundClick("tripper.app", website)}
                        target="_blank"
                        href={website}
                        rel="noopener noreferrer"
                    >
                        <span>{translate("Website")}</span>
                    </a>
                </li>
            )}
            {coords && (
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => trackOutboundClick("tripper.app", website)}
                        // href={`https://maps.google.com/?q=${coords.lat},${coords.lon}&z=8`}
                        // href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                        href={`https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lon}`}
                    >
                        <span>{translate("Google Maps")}</span>
                    </a>
                </li>
            )}
        </ul>
    );
}

export default AtlasCardFooter;
